// extracted by css-extract-rspack-plugin
export default {"root":"pLf0m6"};